import {Injectable} from '@angular/core';
import {SimulationSession} from './SimulationSession';

@Injectable()
export class SimulationSessionProvider {

  private simulationSession: SimulationSession | undefined;

  constructor() {
  }

  public startSimulationSession() {
    this.simulationSession = new SimulationSession();
  }

  public resetSimulationSession() {
    this.simulationSession = new SimulationSession();
  }

  public getSimulationSession() {
    if (!this.simulationSession){
      this.simulationSession = new SimulationSession();
    }
    return this.simulationSession;
  }

}

